/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TargetCrosshairIcon16Light } from './TargetCrosshairIcon16Light';
import { TargetCrosshairIcon16Regular } from './TargetCrosshairIcon16Regular';
import { TargetCrosshairIcon16Solid } from './TargetCrosshairIcon16Solid';
import { TargetCrosshairIcon20Light } from './TargetCrosshairIcon20Light';
import { TargetCrosshairIcon20Regular } from './TargetCrosshairIcon20Regular';
import { TargetCrosshairIcon20Solid } from './TargetCrosshairIcon20Solid';
import { TargetCrosshairIcon24Regular } from './TargetCrosshairIcon24Regular';
import { TargetCrosshairIcon24Solid } from './TargetCrosshairIcon24Solid';
import { TargetCrosshairIcon32Regular } from './TargetCrosshairIcon32Regular';
import { TargetCrosshairIcon64Regular } from './TargetCrosshairIcon64Regular';
var sizes = {
    16: {
        light: TargetCrosshairIcon16Light,
        regular: TargetCrosshairIcon16Regular,
        solid: TargetCrosshairIcon16Solid,
    },
    20: {
        light: TargetCrosshairIcon20Light,
        regular: TargetCrosshairIcon20Regular,
        solid: TargetCrosshairIcon20Solid,
    },
    24: {
        regular: TargetCrosshairIcon24Regular,
        solid: TargetCrosshairIcon24Solid,
    },
    32: {
        regular: TargetCrosshairIcon32Regular,
    },
    64: {
        regular: TargetCrosshairIcon64Regular,
    },
};
export var TargetCrosshairIcon = forwardRef('TargetCrosshairIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
